
<template>
	<c-dialog ref="dialog" mode="slide" width="100vw-300" mask-close @close="dialogFormEditConfirm($refs.orderForm, arguments)" @resolve="submitHandle">
		<c-form ref="orderForm" column="3" vertical unit-width="100%">
			<c-form link-parent>
				<c-form-item label="发货单号">
					<c-input name="deliver_code" placeholder="请输入，不填将自动生成"></c-input>
				</c-form-item>
				<c-form-item label="仓库" required>
					<c-select ref="warehouse" name="warehouse_id" v-model="warehouse_id" async @search="searchWarehouse"  :value-data="warehouseOptions" :clear="false"></c-select>
					<template #handle>
						<c-tooltip tip="发货成功后，将从当前仓库扣减相应产品库存" position="top"></c-tooltip>
					</template>
				</c-form-item>
                <c-form-item label="客户名称">
                    <c-select name="customer_id" async v-model="customer_id" @search="searchCustomer" :value-data="customerOptions" @change="changeCustomer"></c-select>
                    <template #handle>
                        <c-link icon v-if="auth('b_customer_edit')" @click="globalDialog('customerEdit',{})">创建客户</c-link>
                    </template>
                </c-form-item>
				<!--自定义字段数据-->
				<custom-form ref="customForm" work-type="32"></custom-form>
			</c-form>

			<c-title>发货明细</c-title>
			<c-form-item :label="false" name="product_list" colspan="3">
				<custom-table ref="deliverProductTable" view-id="10012" work-type="33">
					<template #operate>
                        <c-button prepend-icon="tf-add" @click="addSendOrder()">添加订单</c-button>
                        <c-button prepend-icon="tf-add" @click="addSendProduct()">添加产品</c-button>
						<c-button prepend-icon="tf-reload" :disabled="!customer_id" @click="loadCustomerOrder()">按客户重新加载待发货明细</c-button>
					</template>
					
					<template #otherOperate>
						<c-button color="red" hollow prepend-icon="tf-clear" @click="clearNonData()">清除无效数据</c-button>
					</template>

					<!--订单|产品-->
					<template #order_number="{data, update}">
                        <c-select v-if="data.type == 1"
							v-model="data.order_product_id"
							name="order_product_id"
							async
							:value-data="data.orderOptions"
							@search="searchOrderProduct"
							@change="changeOrderProduct($event, update)"
                        >
							<template #option="{data, selected}">
								<select-option
									:name="data.name"
									:info="[
										`${data.data.product_code} | ${data.data.product_name} | ${data.data.product_spec}`
									]"
									:selected="selected"
								></select-option>
							</template>
                        </c-select>
                        <span v-else>{{data.order_number || '-'}}</span>
                    </template>
					
					<!--产品编号-->
					<template #product_code="{data, update}">
						<c-select v-if="data.type == 2"
							v-model="data.product_id"
							name="product_id"
							async
							:value-data="data.productCodeOptions"
							@search="searchProduct"
							@change="changeProduct($event, update)"
						>
							<template #option="{data, selected}">
								<select-option
									:name="data.data.product_code"
									:info="[
										`${data.data.product_name} | ${data.data.product_spec}`
									]"
									:selected="selected"
								></select-option>
							</template>
						</c-select>
						<span v-else>{{data.product_code || '-'}}</span>
                    </template>

                    <!--下单数-->
                    <template #main_product_count="{data}">
                        <span v-if="data.main_product_count">{{data.main_product_count}}{{data.unit}}</span>
                        <span v-else>-</span>
                    </template>

					<!--已发货数-->
					<template #over_deliver_count="{data}">
					    <span v-if="data.type==1">{{data.over_deliver_count}}{{data.unit}}</span>
					    <span v-else>-</span>
					</template>
					
					<!--发货数量-->
					<template #aux_deliver_count="{index, data}">
                        <c-input v-if="data.type && data.type>0" :ref="`batch${index}`" name="aux_deliver_count" type="number" v-model="data.aux_deliver_count" decimal="6" :range="[0,99999999]" :clear="false" :readonly="systemConfig.batch_stock == 1" @change="changeCount(data)" :append-text="data.aux_unit" @click.native.stop="batchHandle(index, data)"></c-input>
                        <span v-else>{{data.aux_deliver_count}}{{data.aux_unit}}</span>
					</template>
					
					<!--换算率-->
					<template #aux_unit_count="{data}">
						<c-input v-if="data.type && data.type>0" name="aux_unit_count" type="number" decimal="6" :range="[0.01,99999999]" v-model="data.aux_unit_count" :clear="false" :readonly="systemConfig.batch_stock == 1" @change="changeCount(data)"></c-input>
						<span v-else>{{data.aux_unit_count}}</span>
					</template>
					
					<!--换算率说明-->
					<template #aux_unit_count_tip="{data}">
						<c-tooltip tip="提示" width="360" align="end">
							<template #tip>
								<p>单位转换倍率说明：</p>
								<p>单位换算率为产品主/辅单位之间的转换倍率，计算公式如下：</p>
								<p>发货数量（辅单位）* 换算率 = 发货产品数量（主单位）</p>
								<p>如：1（kg） * 1000 = 1000（g）</p>
								<p>换算率修改后系统会自动计算发货产品数量</p>
							</template>
						</c-tooltip>
					</template>
					
					<!--产品数量-->
					<template #deliver_count="{data}">
						<c-input v-if="data.type && data.type>0" v-model="data.deliver_count" name="deliver_count" type="number" :readonly="systemConfig.batch_stock == 1" decimal="6" :range="[0,99999999]" :clear="false" :append-text="data.unit"></c-input>
						<span v-else>{{data.deliver_count}}{{data.unit}}</span>
					</template>
					
                    <!--操作栏-->
                    <c-table-column
                        type="button"
                        label="操作"
						width="60"
                    >
                        <template #default="{data,remove}">
                            <c-table-button v-if="data.type && data.type>0"  icon="tf-trash" @click="removeProductRow(data,remove)">删除</c-table-button>
                        </template>
						
                    </c-table-column>
					
				</custom-table>
			</c-form-item>
		</c-form>

		<c-window v-if="systemConfig.batch_stock == 1" ref="batchWin" title="按批次发货" width="700" mask-close>
			<template #head>
				<div class="search flex-center">
					<i class="search-icon c-icon-search"></i>
					<input v-model="batchSearchValue" class="flex-grow" autocomplete="off" placeholder="输入批次号进行搜索" @input="searchBatchHandle">
				</div>
			</template>

			<c-table ref="batchList" height="300" :paging="false">
				<c-table-column
					type="selector"
					width="32"
					@handle="updateBatchData('select', $event)"
				></c-table-column>
				<c-table-column
					label="批次号"
					width="260"
					name="batch_code"
				></c-table-column>
				<c-table-column
					label="所属仓库"
					width="75"
					name="warehouse_name"
				></c-table-column>
				<c-table-column
					label="入库时间"
					width="110"
					name="production_date"
				></c-table-column>
				<c-table-column
					label="库存"
					width="65"
					name="product_count"
				></c-table-column>
				<c-table-column
					label="发货数量"
					width="120"
				>
					<template #default="row">
						<c-input v-model="row.data.qty" type="number" decimal="6" :range="[0, row.data.product_count]" :append-text="editBatchData.aux_unit" @change="updateBatchData('input', row)"></c-input>
					</template>
				</c-table-column>
			</c-table>
		</c-window>
	</c-dialog>
</template>

<script>
	import {mapState} from "vuex";
	import {debounce} from '@deanwu/vue-component-library'

	export default {
		name: 'orderDeliverEdit',

		data() {
			return {
				customer_id: '',
				warehouse_id: 0,
				warehouseOptions: [],
                customerOptions: [],
				sendProductList: [],
				deliver_id: 0,

				batchSearchValue: '',
				editBatchData: null
			}
		},
		
		computed: {
			// 获取dictName选项数据
			...mapState(['systemConfig'])
		},

		// 监听器
		watch: {
			//仓库变更，重新查询库存数据
			warehouse_id() {
				var dataList = this.$refs.deliverProductTable.$refs.list.getData();
				if(!dataList.length) return;

				//收集所有产品ID
				var productIds = dataList.filter(item => item.product_id).map(item => item.product_id);

				//按新仓库重新加载产品库存信息
				this.request({
					url:'/product/listSubUnit',
					data: {
						business_type: 2,
						warehouse_id: this.warehouse_id,
						product_ids: productIds
					},
					success: data => {
						dataList.forEach(item => {
							var productAux = data.find(pro => pro.id == item.product_id);
							if(productAux){
								item.product_count = productAux.product_count;
							}
							//批次库存模式：清空批次和发货数量
							if(this.systemConfig.batch_stock == 1){
								item.batch_list = [];
								item.deliver_count = null;
								item.aux_deliver_count = null;
							}
						});
						this.$refs.deliverProductTable.$refs.list.setData(dataList);
					}
				});
			}
		},
		methods: {
			open(data = {}) {
				this.deliver_id = 0;
				let {orderId, deliverId, productList} = data;
				//初始化自定义字段控件
				this.$refs.customForm.init();
				//初始化发货商品表格控件
				this.$refs.deliverProductTable.init();
				//清空表单数据
				this.$refs.orderForm.clear();
				this.getDefaultWarehouse();
				let title = "创建发货单";
				if (orderId) {
					//查询订单详情
					this.request({
						url: '/order/detail',
						data: {
							id: orderId
						},
						loading: true,
						success: data => {
							//处理选中客户信息
							if (data.detailInfo.customer_id) {
								this.customerOptions = [{
									name: data.detailInfo.customer_code + ' | ' + data.detailInfo.customer_name,
									value: data.detailInfo.customer_id
								}];
							}

							//加载订单产品列表
							let ids = [];
							let product_list  = Array.from(productList || data.productList, item => {
								ids.push(item.product_id);
								return {
									type: 1,
									order_id: item.order_id,
									order_product_id: item.id,
									main_product_count: item.main_product_count,
									product_id: item.product_id,
									product_code: item.product_code,
									product_name: item.product_name,
									product_count: item.product_count,
									product_spec: item.product_spec,
									product_price: item.product_price,
									unit: item.unit,
									batch_list:[],
									over_deliver_count: item.deliver_count || 0,
									deliver_count: parseFloat((Math.max(0, item.can_deliver_count || (item.main_product_count - (item.deliver_count || 0)))).toFixed(6)),
									orderOptions: [{
										name: data.detailInfo.order_code,
										value: item.id
									}]
								};
							});
							
							//按选中的产品重新加载产品详细信息
							this.request({
								url:'/product/listSubUnit',
								data: {
									business_type: 2,
									warehouse_id: this.warehouse_id,
									product_ids: ids
								},
								success: async data => {
									this.$refs.deliverProductTable.$refs.list.setData(
										await this.$refs.deliverProductTable.setDefaultData(product_list.map(item => {
											let productAux = data.find(pro => pro.id == item.product_id);
											//默认发货数考虑库存数量
											if(this.systemConfig.order_default_deliver_count_type == 1){
												item.deliver_count = productAux.product_count>item.deliver_count? item.deliver_count:(productAux.product_count<0? 0:productAux.product_count);
											}
											
											//如果开启批次库存，则默认发货数量置空，需要手动选择批次
											if(this.systemConfig.batch_stock == 1){item.deliver_count = null;}
											
											item.aux_unit_id = productAux.aux_unit_id;
											item.aux_unit = productAux.aux_unit;
											item.aux_unit_count = productAux.aux_unit_count;
											if (item.aux_unit == item.unit) {
												item.aux_deliver_count = item.deliver_count;
											}else{
												item.aux_deliver_count = parseFloat((item.deliver_count/item.aux_unit_count).toFixed(6));
											}
											return item;
										}), {
											work_type_id: 33,
											source_list: product_list.map(item => {
												return [{
													ref_work_type_id: 1,
													ref_id: item.order_id
												}, {
													ref_work_type_id: 41,
													ref_id: item.order_product_id
												}, {
													ref_work_type_id: 7,
													ref_id: item.product_id
												}]
											})
										})
									);
								}
							});
						}
					});
				//编辑发货单
				}else if(deliverId != null){
					this.deliver_id = deliverId;
					this.getDetail();
					title = "编辑发货单";
				}
				this.$refs.dialog.open({
					title: title
				});
			},
			
			//查询发货单详情
			getDetail() {
				this.request({
					url: '/order/deliver/detail',
					data: {
						id: this.deliver_id
					},
					loading: true,
					success: data => {
						this.detailData = data.detailInfo;
						
						this.$refs.orderForm.set(this.detailData);
						if (this.detailData && this.detailData.warehouse_id && this.detailData.warehouse_name){
							this.warehouseOptions = [{
								name: this.detailData.warehouse_name + ' | ' + this.detailData.warehouse_code,
								value:this.detailData.warehouse_id
							}];
						}else {
							this.warehouseOptions = [];
						}
						if (this.detailData && this.detailData.customer_id && this.detailData.customer_name){
							this.customerOptions = [{
								name:this.detailData.customer_code +' - ' +this.detailData.customer_name,
								value:this.detailData.customer_id
							}];
						}else {
							this.customerOptions = [];
						}
						
						var product_list = data.productList.map(item => {
							//如果开启批次库存，则发货数量置空，需要手动重新选择批次
							if(this.systemConfig.batch_stock == 1){
								item.batch_list = [];
								item.deliver_count = null;
								item.aux_deliver_count = null;
							}
							if(item.order_product_id){
								item.type = 1;
								item.orderOptions = [{
									name: item.order_number,
									value: item.order_product_id
								}];
							}else{
								item.type = 2;
								item.productCodeOptions = [{
									name: item.product_code + ' | ' + item.product_name,
									value: item.product_id
								}];
							}
							return item;
						});
						
						//加载发货产品列表
						this.$refs.deliverProductTable.$refs.list.setData(product_list);
					}
				});
			},

			changeCustomer({data}) {
				if (!data) return;
				this.$refs.customForm.setDefaultData({
					work_type_id: 32,
					source_list: [[{
						ref_work_type_id: 11,
						ref_id: data.id
					}]]
				});
				//重新加载待发货产品
				this.loadCustomerOrder();
			},
			
			//按客户加载未完成订单明细列表
			loadCustomerOrder(){
				//清空发货产品
				this.$refs.deliverProductTable.$refs.list.setData([]);
				//加载新的可发货产品列表
				this.request({
					url:'/order/can/deliver/list',
					data: {
						customer_id: this.customer_id,
						deliver_id: this.deliver_id
					},
					success:data => {
						
						let ids = [];
						//处理数据
						var product_list = data.map(item => {
							item.type = 1;
							item.order_product_id = item.id;
							item.over_deliver_count = item.deliver_count || 0;
							item.deliver_count = item.wait_deliver_count;
							item.batch_list = [];
							item.orderOptions = [{
								name: item.order_code,
								value: item.id
							}];
							ids.push(item.product_id);
							return item;
						});
						
						//按选中的产品重新加载产品详细信息
						this.request({
							url:'/product/listSubUnit',
							data: {
								business_type: 2,
								warehouse_id: this.warehouse_id,
								product_ids: ids
							},
							success: async data => {
								this.$refs.deliverProductTable.$refs.list.setData(
									await this.$refs.deliverProductTable.setDefaultData(product_list.map(item => {
										let productAux = data.find(pro => pro.id == item.product_id);
										//默认发货数考虑库存数量
										if(this.systemConfig.order_default_deliver_count_type == 1){
											item.deliver_count = productAux.product_count>item.deliver_count? item.deliver_count:(productAux.product_count<0? 0:productAux.product_count);
										}
										
										//如果开启批次库存，则默认发货数量置空，需要手动选择批次
										if(this.systemConfig.batch_stock == 1){item.deliver_count = null;}
										
										item.aux_unit_id = productAux.aux_unit_id;
										item.aux_unit = productAux.aux_unit;
										item.aux_unit_count = productAux.aux_unit_count;
										if (item.aux_unit == item.unit) {
											item.aux_deliver_count = item.deliver_count;
										}else{
											item.aux_deliver_count = parseFloat((item.deliver_count/item.aux_unit_count).toFixed(6));
										}
										return item;
									}), {
										work_type_id: 33,
										source_list: product_list.map(item => {
											return [{
												ref_work_type_id: 1,
												ref_id: item.order_id
											}, {
												ref_work_type_id: 41,
												ref_id: item.order_product_id
											}, {
												ref_work_type_id: 7,
												ref_id: item.product_id
											}]
										})
									})
								);
							}
						});
					}
				})
			},
			
			/**清除无效数据**/
			clearNonData(){
				const dataList = this.$refs.deliverProductTable.$refs.list.getRow();
				for (let i = dataList.length - 1; i >= 0; i--) {
				    const row = dataList[i];
				    const count = row.data?.deliver_count;
				    // 数量为空、undefined、null、0 都判定为无效
				    if (!count || Number(count) === 0) {
						row.remove();
				    }
				}
			},

			/*******搜索可用于发货的【产品列表信息】下拉框信息*****************/
			searchOrderProduct(keyword, resolve){
				this.request({
					url:'/order/can/deliver/list',
					data: {
						customer_id: this.customer_id,
						deliver_id: this.deliver_id,
						keyword: keyword
					},
					success:data => {
						var option = data.map(item => {
							return {
                              name: item.order_code,
                              value: item.id,
                              data: item
							}
						});
						resolve(option);
					}
				})
			},

			/**************查询默认仓库*************/
			getDefaultWarehouse(){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE'
					},
					success:data => {
						if (data.length == 1){
							this.warehouseOptions = [data[0]];
							this.warehouse_id = data[0].value;
						}
					}
				});
			},

			/*******搜索【仓库】下拉框信息*****************/
			searchWarehouse(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

            /*******搜索【客户】下拉框信息*****************/
            searchCustomer(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'CUSTOMER',
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },

			/*******选择产品*****************/
			searchProduct(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'CP_PRODUCT',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/**************变更订单产品下拉框数据******************/
			changeOrderProduct(selectData, update) {
                if (selectData.data) {
					//按选中的产品重新加载产品详细信息
					this.request({
						url: '/product/listSubUnit',
						data: {
							business_type: 2,
							warehouse_id: this.warehouse_id,
							product_ids: [selectData.data.product_id]
						},
						success: async ([data]) => {
							
							let deliverCount = parseFloat(Math.max(0, selectData.data.main_product_count - (selectData.data.deliver_count || 0)).toFixed(6));
							//默认发货数考虑库存数量
							if(this.systemConfig.order_default_deliver_count_type == 1){
								deliverCount = selectData.data.product_count>deliverCount? deliverCount:(selectData.data.product_count<0? 0:selectData.data.product_count);
							}
							
							//如果开启批次库存，则默认发货数量置空，需要手动选择批次
							if(this.systemConfig.batch_stock == 1){deliverCount = null;}
							
							update(await this.$refs.deliverProductTable.setDefaultData(
								Object.assign({}, data, {
									id: null,
									type: 1,
									order_id: selectData.data.order_id,
									order_product_id: selectData.data.id,
									main_product_count: selectData.data.main_product_count,
									product_id: data.id,
									batch_list: [],
									over_deliver_count: selectData.data.deliver_count || 0,
									deliver_count: deliverCount,
									product_price: selectData.data.product_price,
									aux_deliver_count: data.aux_unit == data.unit ? deliverCount : parseFloat((deliverCount/data.aux_unit_count).toFixed(6))
								}),
								{
									work_type_id: 33,
									source_list: [[{
										ref_work_type_id: 1,
										ref_id: selectData.data.order_id
									}, {
										ref_work_type_id: 41,
										ref_id: selectData.data.id
									}, {
										ref_work_type_id: 7,
										ref_id: selectData.data.product_id
									}]]
								}
							))
						}
					});
                } else {
					update({
						batch_list: []
					})
				}
			},

			/**************变更【产品】下拉框数据******************/
			changeProduct(selectData, update) {
				if (selectData.data) {
					//按选中的产品重新加载产品详细信息
					this.request({
						url:'/product/listSubUnit',
						data: {
							business_type: 2,
							warehouse_id: this.warehouse_id,
							product_ids: [selectData.data.id]
						},
						success: async ([data]) => {
							update(await this.$refs.deliverProductTable.setDefaultData(
								Object.assign({}, data, {
									id: null,
									type: 2,
									order_id: 0,
									order_product_id: 0,
									product_id: data.id,
									deliver_count: 0,
									aux_deliver_count: '',
									batch_list: []
								}),
								{
									work_type_id: 33,
									source_list: [[{
										ref_work_type_id: 7,
										ref_id: selectData.data.id
									}]]
								}
							))
						}
					});
				} else {
					update({
						batch_list: []
					})
				}
			},

			/*******添加订单信息【根据订单进行发货】**************************/
			async addSendOrder(){
				if (!this.warehouse_id){
					this.$message({
						message:'请先选择发货仓库',
						type: 'warn'
					});
					return;
				}
                var rowData = {
                    type:1,
                    deliver_count:0,
					batch_list: []
                };
                this.$refs.deliverProductTable.$refs.list.push(
					await this.$refs.deliverProductTable.setDefaultData(rowData)
				);
			},

			/*******添加产品信息【不关联订单进行发货】**************************/
			async addSendProduct(){
				if (!this.warehouse_id){
					this.$message({
						message:'请先选择发货仓库',
						type: 'warn'
					});
					return;
				}
                var rowData = {
                    type:2,
                    order_id:0,
                    order_product_id:0,
                    deliver_count:0,
					batch_list: []
                };
                this.$refs.deliverProductTable.$refs.list.push(
					await this.$refs.deliverProductTable.setDefaultData(rowData)
				);
			},

			/******删除产品行数据********/
			removeProductRow(data, remove) {
				remove();
			},
			
			/****行内数据变更事件**/
			changeCount(data){
				data.deliver_count = parseFloat(((data.aux_deliver_count||0) * (data.aux_unit_count||1)).toFixed(6));
			},

			batchHandle(index, rowData) {
				if (this.systemConfig.batch_stock != 1) return;

				if (this.warehouse_id == 0) {
					this.$message({
						message:'请选择发货仓库',
						type: 'warn'
					});
					return;
				}

				if (!rowData.product_id) {
					this.$message({
						message: rowData.type == 1 ? '请选择发货订单' : '请选择发货产品',
						type: 'warn'
					});
					return;
				}
				
				this.editBatchData = rowData;
				this.$refs.batchList.clear();
				this.request({
					url: '/stock/batch_stock/option',
					data: {
						product_id: rowData.product_id,
						warehouse_id: this.warehouse_id
					},
					success: data => {
						data.forEach(item => {
							let temp = rowData.batch_list.find(temp => temp.id == item.id);
							item.qty = temp ? temp.qty : '';
							item._selected = item.qty > 0;
						});
						this.$refs.batchList.setData(data);
					}
				});
				let rect = this.$refs[`batch${index}`].$el.getBoundingClientRect();
				this.batchSearchValue = '';
				this.$refs.batchWin.open(this.$refs[`batch${index}`], 'bottom', window.innerWidth - rect.right >= 650 ? 'start' : 'end');
			},

			searchBatchHandle: debounce(function() {
				this.$refs.batchList.getRow().forEach(row => {
					if (this.batchSearchValue.trim() && !row.data.batch_code.includes(this.batchSearchValue.trim())) {
						row.hide();
					} else {
						row.show();
					}
				});
			}, 100),

			updateBatchData(type, row) {
				if (type == 'select') {
					if (row.data._selected) {
						if (!row.data.qty) {
							let diff = Math.max(0, this.editBatchData.main_product_count - this.editBatchData.over_deliver_count - this.editBatchData.aux_deliver_count);
							if (diff) {
								row.data.qty = Math.min(diff, row.data.product_count);
							}
						}
					} else {
						row.data.qty = '';
					}
				} else {
					if (row.data.qty > 0) {
						row.select();
					}
				}
				let data = this.$refs.batchList.getData('selected');
				let total = 0;
				this.editBatchData.batch_list = data.filter(item => item.qty > 0);
				this.editBatchData.batch_list.forEach(item => {
					total += parseFloat(item.qty) || 0;
				});
				this.editBatchData.aux_deliver_count = total || '';
				this.editBatchData.deliver_count = parseFloat((total * (parseFloat(this.editBatchData.aux_unit_count) || 1)).toFixed(6));
			},

			/*******提交编辑数据********************/
			submitHandle(stop, next) {
                stop();
                var product_list = this.$refs.deliverProductTable.$refs.list.getData();
                this.$refs.orderForm.submit({
					url: this.deliver_id==0?'/order/deliver/add':'/order/deliver/edit',
                    rule: {
                        warehouse_id:'请选择发货仓库',
                        product_list: data => {
                            var flag = true;
                            if(product_list.length == 0){
                                flag = false;
                                return '请至至少添加一件发货产品';
                            }
							
                            product_list.forEach(item => {
                                if(!item.product_id){
                                  flag = false;
                                }
                                if(!item.aux_deliver_count || parseFloat(item.aux_deliver_count) <= 0){
                                  flag = false;
                                }
								if(!item.aux_unit_count || parseFloat(item.aux_unit_count) <= 0){
								  flag = false;
								}
								if(!item.deliver_count || parseFloat(item.deliver_count) <= 0){
								  flag = false;
								}
                            });
							
							if (!flag) {
								let msg = "请完善产品明细";
								return msg;
							}
							
                            //判断数据是否重复
                            for (var i=0; i<product_list.length; i++) {
								let item = product_list[i];
                                for (var j=i+1; j<product_list.length; j++) {
									if (item.order_id == product_list[j].order_id
											&& item.order_product_id == product_list[j].order_product_id
											&& item.product_id == product_list[j].product_id) {
										flag = false;
										return '第‘'+(i+1)+'’行和第‘'+(j+1)+'’行订单/产品数据重复';
									}
                                }
                            }
							
                            return this.$refs.deliverProductTable.validate();
                        },
                        ...this.$refs.customForm.rule
                    },
                    dataFormatter: data => {
						data.id = this.deliver_id||0;
                        data.customer_id = data.customer_id||0;//发货客户
                        //产品列表
                        data.product_list = product_list.map(item => {
                            return {
                                order_id: item.order_id,
                                order_product_id: item.order_product_id,
                                product_id: item.product_id,
								
								aux_deliver_count: item.aux_deliver_count,
								aux_unit_id: item.aux_unit_id,
								aux_unit_count: item.aux_unit_count,
								
                                deliver_count: item.deliver_count,
								product_price: item.product_price,
                                custom_fields_value_json: JSON.stringify(item.custom_fields_value_json),
								
								batch_list: item.batch_list
                            }
                        });
                        //表单自定义字段
                        data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
                        return data;
                    },
                    success: () => {
                        next();
                        this.$message({
                            type: 'success',
                            message:'发货成功',
                        });
                        //刷新页面
                        this.$emit('resolve');
                    }
                });
            }
		}
	}
</script>

<style lang="stylus" scoped>
	.search {
		box-sizing: border-box;
		width: 200px;
		height: 28px;
		border-radius: 14px;
		padding: 0 10px;
		background: #fff;

		&-icon {
			margin-right: 10px;
			font-size: 16px;
			color: #bbb;
		}

		input {
			height: 100%;
		}
	}
</style>